import { BehaviorSubject, combineLatest } from 'rxjs';
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import { RegionCombo, TextFilter } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * Provides filter for member association pages.
 *
 * @export
 * @class MembersSearchFiltersService
 * @extends {FiltersAbstractService}
 */
export class MembersSearchFiltersService extends FiltersAbstractService {
    /**
     * Creates an instance of MembersSearchFiltersService.
     *
     * @param {HttpClient} http
     * @memberof MembersSearchFiltersService
     */
    constructor(http) {
        super();
        this.http = http;
        this.sharedSubjectForCombo = new BehaviorSubject({ Continent: 'All' });
        // tslint:disable-next-line:max-line-length
        this.regionCombo = new RegionCombo('Region:', 'regionmembercombo', this.http, this.sharedSubjectForCombo, [{ item: { Continent: 'All' }, position: 0 }]);
        this.textFilter = new TextFilter('membersearchinput');
        this.filtersType = [
            this.textFilter.filterInfo,
            this.regionCombo.filterInfo
        ];
    }
    /**
     * {@inheritdoc}
     *
     * @memberof MembersSearchFiltersService
     */
    generateDefaultValues() { }
    /**
     * {@inheritdoc}
     *
     * @returns {[IRegionComboData]}
     * @memberof MembersSearchFiltersService
     */
    getDataStreamWithFilters() {
        return combineLatest([this.orderValue, this.textFilter.data(), this.regionCombo.comboData]);
    }
}
MembersSearchFiltersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MembersSearchFiltersService_Factory() { return new MembersSearchFiltersService(i0.ɵɵinject(i1.HttpClient)); }, token: MembersSearchFiltersService, providedIn: "root" });
